import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import cn from 'classnames';
import { Tooltip } from 'seagull';
import { Edit } from 'seagull/icons';
import styles from './EditableTableCell.module.scss';
export default function EditableTableCell(props) {
    const { children, testId, onClick, className, isDisabled, disabledTooltip } = props;
    const content = /*#__PURE__*/ _jsxs("button", {
        className: styles.button,
        "data-testid": testId,
        disabled: isDisabled,
        onClick: onClick,
        children: [
            /*#__PURE__*/ _jsx("div", {
                children: children
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.icon,
                children: /*#__PURE__*/ _jsx(Edit, {
                    size: 20
                })
            })
        ]
    });
    return /*#__PURE__*/ _jsx("div", {
        className: cn(styles.root, className),
        children: disabledTooltip ? /*#__PURE__*/ _jsx(Tooltip, {
            title: disabledTooltip || '',
            testId: "".concat(testId, "-disabled-tooltip"),
            placement: "right",
            children: content
        }) : content
    });
}
